import addError from '../../../utils/error.jsx';

export function request(sportId, eventTemplateId, id, data) {
    return {
        type: 'MARKET_TEMPLATES_UPDATE_REQUEST',
        eventTemplateId,
        sportId,
        data,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'MARKET_TEMPLATES_UPDATE_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'MARKET_TEMPLATES_UPDATE_FINISH',
        data,
        id
    };
}

export function update(id, data) {
    data.id = id;

    return bulk([ data ]);
}

export function bulk(data) {
    return {
        type: 'MARKET_TEMPLATES_DATA',
        data
    };
}
